import type { IntegrationListItem } from './misc/integration-list-item/integration-list-item';

export type IntegrationComponentT = new (...args: any[]) => IntegrationListItem<any>;

export const componentMap: Record<string, () => Promise<IntegrationComponentT>> = {
  ['partner_integration']: () =>
    import('./integrations/partner/partner-integration-list-item/partner-integration-list-item.component').then(
      k => k.PartnerIntegrationListItemComponent,
    ),
  ['adp']: () =>
    import('./integrations/adp/adp-integration-list-item/adp-integration-list-item.component').then(
      k => k.AdpIntegrationListItemComponent,
    ),
  ['loket']: () =>
    import('./integrations/loket/loket-integration-list-item/loket-integration-list-item.component').then(
      k => k.LoketIntegrationListItemComponent,
    ),

  ['hr2day']: () =>
    import('./integrations/hr2day/hr2day-integration-list-item/hr2day-integration-list-item.component').then(
      k => k.Hr2dayIntegrationListItemComponent,
    ),

  ['tyomarkkinatori']: () =>
    import('./integrations/tyomarkkinatori/tyomarkkinatori-integration-list-item/tyomarkkinatori-integration-list-item.component').then(
      k => k.TyomarkkinatoriIntegrationListItemComponent,
    ),

  ['hacker_rank']: () =>
    import('./integrations/hacker-rank/hacker-rank-integration-list-item/hacker-rank-integration-list-item.component').then(
      k => k.HackerRankIntegrationListItemComponent,
    ),

  ['jitsi']: () =>
    import('./integrations/jitsi/jitsi-integration-list-item/jitsi-integration-list-item.component').then(
      k => k.JitsiIntegrationListItemComponent,
    ),

  ['dev_skiller']: () =>
    import('./integrations/dev-skiller/dev-skiller-integration-list-item/dev-skiller-integration-list-item.component').then(
      k => k.DevSkillerIntegrationListItemComponent,
    ),
  ['officient']: () =>
    import('./integrations/officient/officient-integration-list-item/officient-integration-list-item.component').then(
      k => k.OfficientIntegrationListItemComponent,
    ),

  ['eskill']: () =>
    import('./integrations/eskill/eskill-integration-list-item/eskill-integration-list-item.component').then(
      k => k.ESkillIntegrationListItemComponent,
    ),
  ['gusto']: () =>
    import('./integrations/gusto/gusto-integration-list-item/gusto-integration-list-item.component').then(
      k => k.GustoIntegrationListItemComponent,
    ),
  ['kiwi_hr']: () =>
    import('./integrations/kiwi-hr/kiwi-hr-integration-list-item/kiwi-hr-integration-list-item.component').then(
      k => k.KiwiHrIntegrationListItemComponent,
    ),
  ['jacando']: () =>
    import('./integrations/jacando/jacando-integration-list-item/jacando-integration-list-item.component').then(
      k => k.JacandoIntegrationListItemComponent,
    ),
  ['afas']: () =>
    import('./integrations/afas/afas-integration-list-item/afas-integration-list-item.component').then(
      k => k.AfasIntegrationListItemComponent,
    ),
  ['gfea']: () =>
    import('./integrations/gfea/gfea-integration-list-item/gfea-integration-list-item.component').then(
      k => k.GfeaIntegrationListItemComponent,
    ),

  ['sympa']: () =>
    import('./integrations/sympa/sympa-integration-list-item/sympa-integration-list-item.component').then(
      k => k.SympaIntegrationListItemComponent,
    ),

  ['kununu']: () =>
    import('./integrations/kununu/kununu-integration-list-item/kununu-integration-list-item.component').then(
      k => k.KununuIntegrationListItemComponent,
    ),
  ['teams']: () =>
    import('./integrations/teams/teams-integration-list-item/teams-integration-list-item.component').then(
      k => k.TeamsIntegrationListItemComponent,
    ),

  ['harver']: () =>
    import('./integrations/harver/harver-integration-list-item/harver-integration-list-item.component').then(
      k => k.HarverIntegrationListItemComponent,
    ),

  ['indeed']: () =>
    import('./integrations/indeed/indeed-integration-list-item/indeed-integration-list-item.component').then(
      k => k.IndeedIntegrationListItemComponent,
    ),

  ['predictive_index']: () =>
    import('./integrations/predictive-index/predictive-index-integration-list-item/predictive-index-integration-list-item.component').then(
      k => k.PredictiveIndexIntegrationListItemComponent,
    ),

  ['predictive_index_pi2']: () =>
    import('./integrations/predictive-index/predictive-index-pi2-integration-list-item/predictive-index-pi2-integration-list-item.component').then(
      k => k.PredictiveIndexPI2IntegrationListItemComponent,
    ),

  ['docu_sign']: () =>
    import('./integrations/docu-sign/docu-sign-integration-list-item/docu-sign-integration-list-item.component').then(
      k => k.DocuSignIntegrationListItemComponent,
    ),

  ['hello_sign']: () =>
    import('./integrations/hello-sign/hello-sign-integration-list-item/hello-sign-integration-list-item.component').then(
      k => k.HelloSignIntegrationListItemComponent,
    ),

  ['sign_request']: () =>
    import('./integrations/sign-request/sign-request-integration-list-item/sign-request-integration-list-item.component').then(
      k => k.SignRequestIntegrationListItemComponent,
    ),

  ['zoom']: () =>
    import('./integrations/zoom/zoom-integration-list-item/zoom-integration-list-item.component').then(
      k => k.ZoomIntegrationListItemComponent,
    ),

  ['lucca']: () =>
    import('./integrations/lucca/lucca-integration-list-item/lucca-integration-list-item.component').then(
      k => k.LuccaIntegrationListItemComponent,
    ),

  ['nmbrs']: () =>
    import('./integrations/nmbrs/nmbrs-integration-list-item/nmbrs-integration-list-item.component').then(
      k => k.NmbrsIntegrationListItemComponent,
    ),

  ['enboarder']: () =>
    import('./integrations/enboarder/enboarder-integration-list-item/enboarder-integration-list-item.component').then(
      k => k.EnboarderIntegrationListItemComponent,
    ),

  ['hotelprofessionals']: () =>
    import('./integrations/hotelprofessionals/hotelprofessionals-integration-list-item/hotelprofessionals-integration-list-item.component').then(
      k => k.HotelprofessionalsIntegrationListItemComponent,
    ),

  ['hibob']: () =>
    import('./integrations/hibob/hibob-integration-list-item/hibob-integration-list-item.component').then(
      k => k.HibobIntegrationListItemComponent,
    ),

  ['werken_in_een_hotel']: () =>
    import('./integrations/werken-in-een-hotel/werken-in-een-hotel-integration-list-item/werken-in-een-hotel-integration-list-item.component').then(
      k => k.WerkenInEenHotelIntegrationListItemComponent,
    ),

  ['appical']: () =>
    import('./integrations/appical/appical-integration-list-item/appical-integration-list-item.component').then(
      k => k.AppicalIntegrationListItemComponent,
    ),

  ['bryq']: () =>
    import('./integrations/bryq/bryq-integration-list-item/bryq-integration-list-item.component').then(
      k => k.BryqIntegrationListItemComponent,
    ),

  ['interview_mocha']: () =>
    import('./integrations/interview-mocha/interview-mocha-integration-list-item/interview-mocha-integration-list-item.component').then(
      k => k.InterviewMochaIntegrationListItemComponent,
    ),

  ['test_dome']: () =>
    import('./integrations/test-dome/test-dome-integration-list-item/test-dome-integration-list-item.component').then(
      k => k.TestDomeIntegrationListItemComponent,
    ),

  ['codility']: () =>
    import('./integrations/codility/codility-integration-list-item/codility-integration-list-item.component').then(
      k => k.CodilityIntegrationListItemComponent,
    ),

  ['personio']: () =>
    import('./integrations/personio/personio-integration-list-item/personio-integration-list-item.component').then(
      k => k.PersonioIntegrationListItemComponent,
    ),

  ['bamboo']: () =>
    import('./integrations/bamboo/bamboo-integration-list-item/bamboo-integration-list-item.component').then(
      k => k.BambooIntegrationListItemComponent,
    ),

  ['checkr']: () =>
    import('./integrations/checkr/checkr-integration-list-item/checkr-integration-list-item.component').then(
      k => k.CheckrIntegrationListItemComponent,
    ),
} satisfies Record<string, () => Promise<IntegrationComponentT>>;
